export const systemOneStateFormat = (state) =>
  state !== null && typeof state === 'object' ? 'json' : 'text';

export function normalizeSystemOneParams(body, strict = true) {
  const result = { ...body };
  const format = result.state_format || systemOneStateFormat(result.state);
  delete result.state_format;
  try {
    if (format === 'json') {
      if (typeof result.state === 'string') result.state = JSON.parse(result.state);
      if (result.state === null || typeof result.state !== 'object') {
        throw new Error('state 请选择文本模式，或填写 JSON 对象／数组');
      }
    } else if (typeof result.state !== 'string') {
      throw new Error('文本模式下 state 必须是字符串');
    }
    if (typeof result.questions === 'string') {
      result.questions = JSON.parse(result.questions);
    }
    if (!result.questions || Array.isArray(result.questions) ||
        typeof result.questions !== 'object' || Object.keys(result.questions).length === 0) {
      throw new Error('questions 必须是非空 JSON 对象');
    }
  } catch (error) {
    if (strict) throw new Error(`结构化决策参数错误：${error.message}`);
  }
  return result;
}
